import { Row, Col, Card, Skeleton } from "antd";
import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import { formatDateTime } from "../../helper/DateHelper";
import { useLocation } from "react-router-dom";

function Suggestion() {

  const sectionName = "Brand";
  const routeName = "brand";

  const location = useLocation();
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    request({
      url: apiPath.viewSuggestBrand,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data?.data?.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchData()
  }, [])

  return (
    <Row gutter={16}>
      <Col span={12} xs={24} md={24} className="mb-2">
        <Card title={`${sectionName} Suggestions`}>
          {loading ? (
            <Skeleton active />
          ) : (
            <div className="view-main-list">
              <Row gutter={[16, 16]}>
                {list.length > 0 ? (
                  list.map((item, index) => (
                    <Col xs={24} sm={12} md={6} lg={6} key={index}>
                      <div className="brand-card">
                        
                        <h5 className="brand-title">
                          {index + 1}. {item.search || '-'}
                        </h5>

                        <p className="brand-date">
                          {formatDateTime(item.created_at)}
                        </p>
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col span={24}>
                    <div className="no-data">No suggestions found.</div>
                  </Col>
                )}
              </Row>

              <div className="view-inner-cls float-right mt-4">
                <Link
                  className="ant-btn ant-btn-secondary"
                  to={`/${routeName}${location.search}`}
                >
                  <i className="fas fa-arrow-left mr-5"></i> Back
                </Link>
              </div>
            </div>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default Suggestion;
